import { readRuntimeConfig } from './runtimeConfig';
import { resolveApiEndpoint } from './resolveApiEndpoint';

export const LOCAL_SIGN_IN_PARAM = 'localSignIn';

export type LocalSignInReason = 'standin-deployment' | 'cloud-deployment' | 'disabled-by-param';

export type LocalSignInDecision = {
  useLocalSignIn: boolean;
  reason: LocalSignInReason;
};

export type ResolveLocalSignInInput = {
  isStandinDeployment?: boolean;
  urlParam?: string;
};

export function resolveLocalSignIn({
  isStandinDeployment = false,
  urlParam,
}: ResolveLocalSignInInput): LocalSignInDecision {
  if (urlParam === 'false') {
    return { useLocalSignIn: false, reason: 'disabled-by-param' };
  }

  return isStandinDeployment
    ? { useLocalSignIn: true, reason: 'standin-deployment' }
    : { useLocalSignIn: false, reason: 'cloud-deployment' };
}

export type LocalSignInEnvironment = {
  location?: Location;
  params?: Record<string, string | undefined>;
};

export function resolveLocalSignInForEnvironment({
  location,
  params,
}: LocalSignInEnvironment = {}): LocalSignInDecision {
  const target = location ?? (typeof window === 'undefined' ? undefined : window.location);
  if (!target) return { useLocalSignIn: false, reason: 'cloud-deployment' };

  try {
    const { isStandinDeployment } = resolveApiEndpoint({
      host: target.host,
      origin: target.origin,
      pathname: target.pathname,
      runtimeConfig: readRuntimeConfig(),
    });

    return resolveLocalSignIn({
      isStandinDeployment,
      urlParam: params?.[LOCAL_SIGN_IN_PARAM],
    });
  } catch {
    return { useLocalSignIn: false, reason: 'cloud-deployment' };
  }
}

export function isLocalSignInDeployment(environment?: LocalSignInEnvironment): boolean {
  return resolveLocalSignInForEnvironment(environment).useLocalSignIn;
}

export default resolveLocalSignIn;
